import { Splide } from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function (e) {
    const jsReviewsSlider = e.target.querySelector('.js-reviews-slider')

    if (jsReviewsSlider) {
        const splideInstanceReviews = new Splide(jsReviewsSlider, {
            perPage: 4,
            arrows: false,
            pagination: false,
            gap: '30px',
            breakpoints: {
                991: {
                    perPage: 2,
                    gap: '10px',
                    padding: { right: '3%' },
                },
                768: {
                    perPage: 1,
                    padding: { right: '0%' },
                },
            },
        })
        splideInstanceReviews.mount()
    }
})
